/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeaderSectionParameters
 */
export interface HeaderSectionParameters {
    /**
     * 
     * @type {string}
     * @memberof HeaderSectionParameters
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof HeaderSectionParameters
     */
    useCompanyLogo?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HeaderSectionParameters
     */
    logoUrl?: string;
}

/**
 * Check if a given object implements the HeaderSectionParameters interface.
 */
export function instanceOfHeaderSectionParameters(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function HeaderSectionParametersFromJSON(json: any): HeaderSectionParameters {
    return HeaderSectionParametersFromJSONTyped(json, false);
}

export function HeaderSectionParametersFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeaderSectionParameters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': json['description'],
        'useCompanyLogo': !exists(json, 'use_company_logo') ? undefined : json['use_company_logo'],
        'logoUrl': !exists(json, 'logo_url') ? undefined : json['logo_url'],
    };
}

export function HeaderSectionParametersToJSON(value?: HeaderSectionParameters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'use_company_logo': value.useCompanyLogo,
        'logo_url': value.logoUrl,
    };
}

